import { Component, SimpleChanges, ChangeDetectorRef, ElementRef, ViewChildren, QueryList, Input, PLATFORM_ID, Inject, Output, EventEmitter, ViewChild, HostListener } from '@angular/core';
import { interval, from, throwError,Subscription,Observable } from 'rxjs';
import { switchMap, catchError, takeWhile, map, take } from 'rxjs/operators'
import { Store } from '@ngrx/store';

import { ComponentBase } from '@framework/base/component/component.base';
import { mediaDOwnloadSeclector, mediaSelectors } from '@app/store/features/media/selectors';
import { CoreState } from '@app/store/core/states';
import { mediaActions, mediaDownloadAction, mediaRecordAction } from '@app/store/features/media/actions';
import { MediaViewModel } from '@app/store/features/media/models';
import { PaginationModel } from '@framework/models/pagination-models';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, FormArray } from '@angular/forms';
import { UploaderService, ModalService, ToastService, LoadingPopupService } from '@framework/services';
import { UploaderConfig, Callback } from '@framework/models';
import { CreateMediaInputApiModel } from '@app/store/http/models/input';
import { storySelector, storyBuilderSelector } from '@modules/story/store/selectors';
import { storyBuilderActions, storyStepActions } from '@modules/story/store/actions';
import { debounceTime, withLatestFrom } from 'rxjs/operators';
import { Constants } from '@modules/shared/constants';
import { LoadMediaInputApiModel } from '@app/store/http/models/input';
import { UtilityHelper } from '@framework/utilities';
import { StoryOutputApiModel } from '@modules/story/models/api-models/output';
import { Actions, ofType } from '@ngrx/effects';
import * as filestack from 'filestack-js';
import { isPlatformBrowser } from '@angular/common';
import { inspectVideoUploadSize, ScreenWakeLock, shouldShrinkMobileVideo } from '@modules/story/components/storyflow-card-preview/upload-ux.util';
import { shrinkMobileCameraRoll } from '@modules/story/components/storyflow-card-preview/shrink-mobile-video';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StoryHttpService } from '@modules/company-admin/store/services';
import { PhotoGalleryHttpService, CampaignMediaGroupApiModel } from '@modules/company-admin/store/services/photo-gallery.http-service';
import {
  PHONE_UPLOAD_MAX_FILES,
  PhoneFileFeeder,
  PhoneUploadContext,
  PhoneUploadFile,
  PhoneUploadPanelMounter,
  STORY_MEDIA_ACCEPT
} from '@modules/shared/phone-upload';
import { createComputerUploadPlugin } from '@modules/shared/uploadcare';
import { galleryThumbnailUrl } from '@modules/company-admin/pages/gallery/gallery-thumbnail-url';
// import { VideoRecorderMediaComponent } from '../video-recorder-media';
declare global {
  interface Window {
    Canva;
    api;
  }
} 
@Component({
  selector: 'app-storyflow-card-gallery-request',
  templateUrl: './storyflow-card-gallery-request.component.html',
  styleUrls: ['./storyflow-card-gallery-request.component.scss']
})
export class StoryflowCardGalleryRequestComponent extends ComponentBase {
    isSmallScreen: boolean = window.screen.width <= 700;
    @HostListener('window:resize', ['$event'])
    onResize(event: any){
      this.isSmallScreen = window.screen.width <= 700;
    }
  @Input() reduceHeight: boolean = false;
  @Input()  videoduration:any;
  @Input()  inbound_builder: boolean;
  @Input()  companyID:any;
  @Input() campaignId: number = null;
  @Input() questionModels:any[] = [];
  @Input() showPreviousNextButton:boolean = false;
  @Input() currentCompany:any;
  @Input() interviewStyle : any;
  @Input() isPreview:  any
  @Input() storyParam:any;
  @Input() storyflowMenu:any;
  @Input() menuActive:any;
  @ViewChildren('browseFileButton', { read: ElementRef })
  browseFileButton: QueryList<ElementRef>;
  @Output() campaignDetailAction:EventEmitter<any> = new EventEmitter<any>();
 @ViewChild('fileInput') fileInput: ElementRef;
 @ViewChild('mobilefileInput') mobilefileInput: ElementRef;
  private loadStoryMedia$: Observable<any>;
  public showIndicator: boolean = false;
  public disabled: boolean = false;
  public isCamera:boolean = false;
  public fileSize:number = 0;
  private cameraRollFile: File | null = null;
  public idhistory:any[] = [];
  public totalDatainmedai:number = 0;
  public apiCollection:any;
  private phoneUploadContextCache: PhoneUploadContext;
  private phoneFileFeeder = new PhoneFileFeeder(
    () => this.apiCollection,
    () => document.querySelector('uc-upload-ctx-provider')
  );
  public remaningunsplashids:any[] = []
  public uploadedId:any[] = [];
  private getMediaCoutSubscription: Subscription;
  public isGalleryActivated:boolean = false;
  /** Gallery off: placeholders fill one row of four; more uploads scroll sideways. */
  totalSlots = 4;
  slots: any[] = [];
  private getNextUrl$: Observable<string>;
  private getMediacount: Observable<any>;
  private getCreatedMediaId$: Observable<number>;
  private selectStoryCreating$: Observable<boolean>;
  private selectStepActive$: Observable<any>;
  private selectStepSelectedData$: Observable<any>;
  private selectStoryData$: Observable<StoryOutputApiModel>;
  private selectCompanyId$: Observable<number>;
  private selectInbound$: Observable<boolean>;
  private selectMediaLoading$: Observable<boolean>;

  private selectStoryCreatingSubscription: Subscription;
  private getNextUrlSubscription: Subscription;
  private getCreatedMediaIdSubscription: Subscription;
  private selectStepActiveSubscription: Subscription;
  private combineSubscription: Subscription;
  public downloaded: boolean = false;
  public normalFile:any;
  public mediaCreating:boolean = false;
  public getMediaDonwloaded$: Observable<any>;
  private downloadedSubcription: Subscription;
  private selectStoryDataSubscription: Subscription;
  private selectMediaLoadingSubscription: Subscription;
  private addOptionSuccessSubscription: Subscription;
  private searchTextSubscription: Subscription;
  private resetSearhBarSubscription: Subscription;

  private loadMediaInputData: LoadMediaInputApiModel = new LoadMediaInputApiModel(new PaginationModel(30));
  private uploader: any;
  public abortController: AbortController;
  public signal:any;
  public uploaderInstance;
  public uploadedUrl: any;
  public stream:any;
  public checkIfVideoOrNot:boolean = false;
  public color:string = '';
  public disableSubmit: boolean =false;
  public mapId:any=[];
  public normalVideoUpload: Subscription;
  private mediaSubscription: Subscription;
  public notifymessage:any;
  public loadDataSubscription: Subscription;
  public dynamicObject:any;
  private videoMaxDurationAccepted: number; //seconds
  public galleries: Array<MediaViewModel> = [];
  public photoGalleryGroups: Array<{ id: number; name: string; items: Array<MediaViewModel> }> = [];
  public useGroupedGalleries: boolean = false;
  private pendingCampaignGroups: Array<{ id: number; name: string; mediaIds: number[] }> = null;
  private lastLoadedCampaignId: number = null;
  private campaignHydrateToken: number = 0;
  /** Company id from the story builder store; the `companyID` input wins (the store is reset on User ↔ Guest). */
  private storeCompanyId: number = null;
  /** Only a flat load started by this gallery may fill the list; the media store is shared app-wide. */
  private expectGalleryLoadResult = false;
  private groupedLoadSub: Subscription = null;
  /** What the grouped list currently shows, so a different campaign/company clears it while loading. */
  private currentLoadKey: string = null;
  private started = false;
  private static readonly UPLOADS_GROUP_ID = 0;
  public loadMore: boolean = true;
  public form: UntypedFormGroup;
  public processingCompletes:boolean = false;
  public bigFileReminderCounter = 0

  public messageIndex:number = 0;
  public uploadMessages = [
    "Uploading in the works.",
    "Still doing its thing."
    ];
  public uploaderViewModel: any = {
    errorMsg: 'An error occurred while uploading.',
    isError: false,
    progress: 0,
    progressCss: '0%',
    isUploading: false
  };
  public viewmodel = {
    isStoryCreating: false,
    companyId: 0,
    isInbound: false,
    scrollbarVisible: false,
    isMediaLoading: false
  };
  public stepActive: any;
  public progessCss:HTMLElement;
  public selectedData: number[] = [];
  public storyData: StoryOutputApiModel;
  processingFinalMessages = [
    "Preparing to display …",
    "We’re close …"
  ];
  
  processingRotationIndex = 0;
  notificationProcess:boolean = false;
  processingMsgInterval: any;
  public filterTabObj = {
    items: [
      { id: 1, label: 'Global', filterFunc: this.filterMediaByGlob.bind(this) },
      //{ id: 2, label: 'Company', filterFunc: this.filterMediaByComp.bind(this) }
    ],
    tabActive: 1
  };
  public isShowRecorder: boolean = false;
  public isGalleriesLoading: boolean = false;
  // False until the media step's gallery setting is known and a load has begun,
  // so the empty-state messages don't flash while the panel opens.
  public galleryLoadStarted = false;
  // isGalleryActivated defaults to false, so loading before the media step
  // arrives would take the "gallery off" path and flash its message.
  private galleryStateKnown = false;
  public searchBarVisible: boolean = false;
  public isBrowser: boolean;
  public searchText: UntypedFormControl;
  public resultFrom: UntypedFormControl;
  public updatedMenu:any[] = [];

  constructor(
    private store$: Store<CoreState>,
    private detector: ChangeDetectorRef,
    @Inject(PLATFORM_ID) platformId: Object,
    private formBuilder: UntypedFormBuilder,
    private uploaderService: UploaderService,
    private httpClient: HttpClient,
    private utility: UtilityHelper,
    private actions$: Actions,
    private toastService: ToastService,
    private loadingPopupService: LoadingPopupService,
    private storyHttpService: StoryHttpService,
    private modalService: ModalService,
    private photoGalleryHttpService: PhotoGalleryHttpService,
    private hostElement: ElementRef,
    private phoneUploadMounter: PhoneUploadPanelMounter
  ) {
    super();

    this.initForm();
    this.abortController = new AbortController();
    this.signal = this.abortController.signal
    this.isBrowser = isPlatformBrowser(platformId);
    this.loadStoryMedia$ = this.store$.select(mediaSelectors.selectMedia);
    this.getNextUrl$ = this.store$.select(mediaSelectors.selectNextUrl);
    this.getCreatedMediaId$ = this.store$.select(mediaSelectors.selectCreatedMediaId);
    this.selectStoryCreating$ = this.store$.select(storySelector.selectCreating);
    this.selectStepActive$ = this.store$.select(storyBuilderSelector.selectStepActive);
    this.selectStepSelectedData$ = this.store$.select(storyBuilderSelector.selectStoryStepSelected);
    this.selectStoryData$ = this.store$.select(storyBuilderSelector.selectStoryData);
    this.selectCompanyId$ = this.store$.select(storyBuilderSelector.selectCompanyId);
    this.selectInbound$ = this.store$.select(storyBuilderSelector.selectInbound);
    this.selectMediaLoading$ = this.store$.select(mediaSelectors.selectLoading);
    this.getMediacount = this.store$.select(mediaDOwnloadSeclector.selectNumber);
    this.getMediaDonwloaded$ = this.store$.select(mediaDOwnloadSeclector.selectId);
  }

  protected onInit(): void {
    navigator.mediaDevices
    .getUserMedia({ audio: true,video:true })
    .then((stream)=>{
      stream.getTracks().forEach(track => track.stop());
    })
    this.videoMaxDurationAccepted = (this.videoduration * 60) + 10;
    this.viewmodel.companyId = this.resolveCompanyId();
    this.subscribe();
    this.started = true;
    this.getLocalStream();
    this.getEditor();
    if(this.isBrowser) {
      this.uploadData();
    }
    //this.recordingComplte();
    //this.loadHippoScript()
    // this.initUploader();



  }

  protected onDestroy(): void {
    this.destroyLocalstream();
   // this.destoryScript();
   this.abortController.abort();
   
    this.unSubcription();
  }
  protected onChanges(changes: SimpleChanges): void {

    if(this.storyflowMenu && this.storyflowMenu.length){
      this.updatedMenu = this.storyflowMenu.filter((item)=> item.id != 16);
    }

    if (changes.companyID) {
      this.viewmodel.companyId = this.resolveCompanyId();
    }

    // Before onInit the media step subscription does the first load.
    const campaignChanged = !!(changes.campaignId || changes.questionModels);
    if (this.started && campaignChanged && this.viewmodel.companyId) {
      const nextCampaignId = this.resolveCampaignId();
      if (nextCampaignId !== this.lastLoadedCampaignId) {
        this.loadMedia();
      }
    }
  }
  protected onDoCheck(): void {

  }
  protected onAfterContentInit(): void {

  }
  protected onAfterContentChecked(): void {

  }
  protected onAfterViewInit(): void {
    this.connectUploaderPlugins();
  }
  protected onAfterViewChecked(): void {

  }

  private subscribe() {

    this.loadDataSubscription = this.actions$.pipe(
      ofType<storyStepActions.AddMediaObject>(storyStepActions.ActionTypes.ADD_TO_OBJECT) // listen for the action
    ).subscribe((action: any) => {
      
      // If key doesn't exist, create it
  
      this.dynamicObject = action.value;
  
    
      // console.log('Merged dynamicObject in Component B:', this.dynamicObject);
    });

    this.getMediaCoutSubscription = this.getMediacount.subscribe((staus: number)=>{
      if(staus != undefined){
        this.totalDatainmedai = staus
      }

    })
    this.downloadedSubcription = this.getMediaDonwloaded$.subscribe((staus)=>{
      
      if(staus != undefined){
        if(this.selectedData.length)
        this.selectedData = this.selectedData.filter(item => item != staus)
        this.updateSelectedValues();
      }

    })
    this.mediaSubscription = this.actions$.pipe(
      ofType<mediaDownloadAction.CheckDownloaf>(mediaDownloadAction.ActionTypes.CHECK_DOWNLOAD)
    ).subscribe((action: any) => {
        if(action.download){
          this.disableSubmit = true;
        }
        else{
          this.disableSubmit = false;
        }
      

    })

    this.normalVideoUpload  = this.actions$.pipe(
      ofType<mediaActions.NormalVideoUpload>(mediaActions.ActionTypes.NORMAL_VIDEO_UPLOAD)
    ).subscribe((action) =>  {
       if(action.isNormal){
        this.commonUploadFuctionality();
       }
    })

    this.resetSearhBarSubscription = this.actions$.pipe(
      ofType<mediaDownloadAction.HideSearchBar>(mediaDownloadAction.ActionTypes.HIDESEARCHBAR)
    ).subscribe(() =>  {
      this.hideSearchBar();
    })
    this.getNextUrlSubscription = this.getNextUrl$.subscribe((nextUrl) => {
      this.loadMore = nextUrl !== null;
      if(this.loadMore){
        this.disabled = false;
      } else {
        this.disabled = true;
      }
      this.detector.detectChanges();
    });

    this.getCreatedMediaIdSubscription = this.actions$.pipe(
      ofType<mediaActions.CreateSuccess>(mediaActions.ActionTypes.CREATE_SUCCESS)
    ).subscribe((createdMediaId) =>  {
      
      if (createdMediaId && createdMediaId.response?.id && createdMediaId.response.id > 0 && !this.selectedUnsplashMedia) {
        // this.form.controls.media.setValue(createdMediaId);
        this.selectedData.push(createdMediaId.response.id);
        if(this.showIndicator){
          this.store$.dispatch(new mediaActions.checkAssetReadyOrNot(true,'Video uploaded successfully','100%'));
          this.store$.dispatch(new mediaActions.checkAssetReadyOrNot(true,'Video Processing in background','1%'))
          this.store$.dispatch(new mediaActions.checkAssetReadyOrNot(false,'The video will be added after processing. Submit your story.','2%'))
        }
        // this.totalDatainmedai = this.selectedData.length
        // this.selectItem();
        var data = [...this.selectedData]
        this.loadMediaInputData.selectedValues = this.selectedData
        this.selectedData = [];
        this.selectedData = [...data]
        this.downloaded = false;
        this.store$.dispatch(new mediaDownloadAction.CheckDownloaf(false))
        this.loadMedia();
        this.dynamicObject= {16 : this.selectedData}
        this.store$.dispatch(new storyStepActions.AddMediaObject(this.dynamicObject))
        this.store$.dispatch(new storyBuilderActions.UpdateStoryStepSelected(this.stepActive.id, this.selectedData));
        // this.updateSelectedValues();
        this.uploaderViewModel.progressCss = 100+'%'
        this.uploaderViewModel.isUploading = false;
        this.loadingPopupService.hide();
        this.mediaCreating = false;
        if(this.showIndicator || createdMediaId.response.type.includes('video')){
          this.showIndicator = false;
          this.store$.dispatch(new mediaActions.checkAssetReadyOrNot(false,'The video will be added after processing. Submit your story.','100%'))
        }

      } else if (this.selectedUnsplashMedia && this.mediaCreating) {
        var updatedselectedData = this.selectedData.filter(item => item !== this.selectedUnsplashMedia.id)
        let obj = {
          oldid: this.selectedUnsplashMedia.id,
          newId:createdMediaId.response.id
        }
        this.idhistory.push(obj)
        this.selectedData.push(createdMediaId.response.id);
        this.selectedData = this.selectedData.filter(id => id !== this.selectedUnsplashMedia.id);
        this.galleries = this.galleries.filter(item => item.id !== this.selectedUnsplashMedia.id)
        updatedselectedData.push(createdMediaId.response.id)
        // this.totalDatainmedai = updatedselectedData.length

        this.dynamicObject= {16 : updatedselectedData}
            this.store$.dispatch(new storyStepActions.AddMediaObject(this.dynamicObject))
        this.store$.dispatch(new storyBuilderActions.UpdateStoryStepSelected(this.stepActive.id, updatedselectedData));
        this.updateSelectedValues();
        // this.galleries.shift();
        this.loadingPopupService.hide();
        this.downloaded = false;
        this.mediaCreating = false;
        this.store$.dispatch(new mediaDownloadAction.CheckDownloaf(false))
      }
    });

    this.selectStoryCreatingSubscription = this.selectStoryCreating$.subscribe((creating: boolean) => {
      this.viewmodel.isStoryCreating = creating;

      this.detector.detectChanges();
    });

    this.selectStepActiveSubscription = this.selectStepActive$.pipe(
      withLatestFrom(
        this.selectStepSelectedData$
      )
    ).subscribe(([stepActive, selectedData]) => {
      if (stepActive && stepActive.type === Constants.stepType.media) {
        this.stepActive = stepActive;
        this.color = stepActive?.color
        this.isGalleryActivated = stepActive?.is_active
        this.galleryStateKnown = true;
        if (selectedData) {
          this.loadMediaInputData.selectedValues = selectedData;
          // this.totalDatainmedai = selectedData.length;
        }
         
        this.selectedData = selectedData == null ? [] : selectedData;

        // this.totalDatainmedai = this.selectedData.length;
        this.dynamicObject= {16 : this.selectedData}
        this.store$.dispatch(new storyStepActions.AddMediaObject(this.dynamicObject))

        this.updateSelectedValues();
        // Same race as Submit Story: campaign galleries must reload when media opens.
        if (this.viewmodel.companyId) {
          this.loadMedia();
        }
      }
    });

    this.combineSubscription = this.selectInbound$.pipe(
      withLatestFrom(
        this.selectCompanyId$
      )
    ).subscribe(([isInbound, companyId]) => {
      this.storeCompanyId = companyId;
      this.viewmodel.companyId = this.resolveCompanyId();
      this.viewmodel.isInbound = isInbound;
      this.filterMediaByTab(this.filterTabObj.tabActive);
      setTimeout(() => {
        this.initUploader();
      }, 100);
    });

    this.selectStoryDataSubscription = this.selectStoryData$.subscribe((storyData) => {
      this.storyData = storyData;
    });

    this.selectMediaLoadingSubscription = this.selectMediaLoading$.subscribe((isLoading) => {
      this.viewmodel.isMediaLoading = isLoading;
    });

    // The media store is shared app-wide and keeps whatever list was loaded last,
    // so only show it when a flat load started by this gallery has finished.
    this.addOptionSuccessSubscription = this.actions$.pipe(
      ofType<mediaActions.LoadSuccess>(mediaActions.ActionTypes.LOAD_SUCCESS)
    ).subscribe(() => {
      // Someone else's media load must not end this gallery's loading state.
      if (!this.expectGalleryLoadResult || this.useGroupedGalleries) {
        return;
      }
      this.isGalleriesLoading = false;
      this.expectGalleryLoadResult = false;
      this.loadStoryMedia$.pipe(take(1)).subscribe((data) => {
        let items = data || [];
        // The flat endpoint returns the selected media followed by stock/gallery
        // images; with the gallery off, keep only what the user uploaded.
        if (!this.isGalleryActivated && !this.loadMediaInputData.searchText) {
          const uploaded = this.selectedData || [];
          items = items.filter(item => uploaded.includes(item.id));
        }
        this.galleries = items.map(item => ({...item, isActive: false}));
        this.detector.detectChanges();
        this.updateSelectedValues();
      });
    });

    this.searchTextSubscription = this.searchText.valueChanges.pipe(debounceTime(300)).subscribe(text => {
      this.loadMediaInputData.searchFrom = this.resultFrom.value;
      this.loadMediaInputData.searchText = text;
      this.loadMediaInputData.pagination.limit = 100;
      this.loadMedia();
    })
  }

  private unSubcription() {
    this.cancelGroupedLoad();
    this.getNextUrlSubscription.unsubscribe();
    this.getMediaCoutSubscription.unsubscribe();
    this.getCreatedMediaIdSubscription.unsubscribe();
    this.selectStoryCreatingSubscription.unsubscribe();
    this.selectStepActiveSubscription.unsubscribe();
    this.combineSubscription.unsubscribe();
    this.selectStoryDataSubscription.unsubscribe();
    this.selectMediaLoadingSubscription.unsubscribe();
    this.addOptionSuccessSubscription.unsubscribe();
    this.searchTextSubscription.unsubscribe();
    this.downloadedSubcription.unsubscribe();
    this.resetSearhBarSubscription.unsubscribe();
  }

  private positiveId(value: any): number {
    const id = Number(value);
    if (!id || isNaN(id) || id <= 0) {
      return null;
    }
    return id;
  }

  private resolveCompanyId(): number {
    return this.positiveId(this.companyID) || this.positiveId(this.storeCompanyId);
  }

  // Gallery off and nothing uploaded yet.
  get showGalleryOffState(): boolean {
    return this.galleryLoadStarted && !this.isGalleriesLoading && !this.galleries.length;
  }

  // Desktop shows the QR code and empty tiles instead, so the message is for phones only.
  get showGalleryOffMessage(): boolean {
    return this.showGalleryOffState && !this.showPhoneUpload;
  }

  get isCampaignSelected(): boolean {
    return !!this.resolveCampaignId();
  }

  // Gallery on, but nothing to show (e.g. the campaign has no gallery attached).
  get showNoGalleryState(): boolean {
    const searching = !!(this.searchText?.value || '').toString().trim();
    return this.galleryLoadStarted && !this.isGalleriesLoading && !searching && !this.galleries.length
      && !(this.useGroupedGalleries && this.photoGalleryGroups.length);
  }

  private resolveCampaignId(): number {
    const fromInput = this.positiveId(this.campaignId);
    if (fromInput) {
      return fromInput;
    }
    if (this.questionModels && this.questionModels.length) {
      for (const question of this.questionModels) {
        const fromQuestion = this.positiveId(question && (question.campaign_id || question.id_campaign));
        if (fromQuestion) {
          return fromQuestion;
        }
      }
    }
    return null;
  }

  private mediaItemHasDisplay(item: any): boolean {
    return !!(item && (item.preview || item.fullsize || item.url || item.source || item.thumbnail_url));
  }

  private applyCampaignGroupedResponse(groups: CampaignMediaGroupApiModel[]) {
    this.useGroupedGalleries = true;
    this.photoGalleryGroups = (groups || []).map((group: CampaignMediaGroupApiModel) => ({
      id: group.id,
      name: group.name,
      items: (group.items || []).map(item => ({ ...item, isActive: false }))
    }));
    this.galleries = this.photoGalleryGroups.reduce((acc, g) => acc.concat(g.items), []);

    const needsHydrate = this.galleries.some(item => item && item.id && !this.mediaItemHasDisplay(item));
    if (needsHydrate) {
      const pending = this.photoGalleryGroups.map(group => ({
        id: group.id,
        name: group.name,
        mediaIds: (group.items || []).map(item => Number(item.id)).filter(id => !!id)
      }));
      this.pendingCampaignGroups = pending;
      const token = ++this.campaignHydrateToken;
      this.hydrateCampaignMediaFromCompanyPool(pending, token);
      return;
    }

    this.pendingCampaignGroups = null;
    this.updateSelectedValues();
    this.isGalleriesLoading = false;
    this.detector.detectChanges();
    this.addSelectedUploadsGroup(this.campaignHydrateToken);
  }

  private hydrateCampaignMediaFromCompanyPool(
    pending: Array<{ id: number; name: string; mediaIds: number[] }>,
    token: number
  ) {
    const companyId = Number(this.viewmodel.companyId || this.companyID);
    const mediaIds = (pending || []).reduce((acc, group) => acc.concat(group.mediaIds || []), [] as number[]);

    if (!companyId || !mediaIds.length) {
      this.applyHydratedCampaignGroups(pending, [], token);
      return;
    }

    this.httpClient.get(`/api/v3/companies/${companyId}/setting/images/`).subscribe(
      (response: any) => {
        if (token !== this.campaignHydrateToken) {
          return;
        }
        const mapped = this.mapCompanySettingImages(response);
        const hitCount = this.countHydrationHits(pending, mapped);
        if (hitCount > 0) {
          this.applyHydratedCampaignGroups(pending, mapped, token);
          return;
        }
        this.hydrateCampaignMediaBySelectedIds(pending, companyId, mediaIds, token);
      },
      () => {
        if (token !== this.campaignHydrateToken) {
          return;
        }
        this.hydrateCampaignMediaBySelectedIds(pending, companyId, mediaIds, token);
      }
    );
  }

  private hydrateCampaignMediaBySelectedIds(
    pending: Array<{ id: number; name: string; mediaIds: number[] }>,
    companyId: number,
    mediaIds: number[],
    token: number
  ) {
    const selected = mediaIds.join(',');
    const url =
      `/api/v3/companies/${companyId}/media/?selected=${encodeURIComponent(selected)}&page=1&limit=${Math.max(mediaIds.length, 30)}`;

    this.httpClient.get(url).subscribe(
      (response: any) => {
        if (token !== this.campaignHydrateToken) {
          return;
        }
        this.applyHydratedCampaignGroups(pending, this.mapCompanyMediaList(response), token);
      },
      () => {
        if (token !== this.campaignHydrateToken) {
          return;
        }
        this.applyHydratedCampaignGroups(pending, [], token);
      }
    );
  }

  /** Maps the `/companies/<id>/media/?selected=…` list. */
  private mapCompanyMediaList(response: any): MediaViewModel[] {
    const list = (response && (response.result || response.results || response.data)) || [];
    return (Array.isArray(list) ? list : []).map((item: any) => ({
      id: Number(item.id),
      type: item.type || 'image/jpeg',
      preview: item.preview || item.url || item.fullsize || '',
      fullsize: item.fullsize || item.url || item.preview || '',
      saveIn: item.save_in || item.saveIn || 0,
      url: item.url || item.preview || item.fullsize || '',
      thumbnail_url: item.thumbnail_url,
      source: item.source,
      asset_id: item.asset_id,
      isActive: false
    } as MediaViewModel));
  }

  private mapCompanySettingImages(response: any): MediaViewModel[] {
    const list = Array.isArray(response)
      ? response
      : (response && Array.isArray(response.results) ? response.results
        : (response && Array.isArray(response.result) ? response.result : []));

    return (list || []).map((item: any) => {
      const image = item && item.image ? item.image : {};
      const url = image.url || item.url || '';
      return {
        id: Number(item.id),
        type: image.type || item.type || 'image/jpeg',
        preview: url,
        fullsize: url,
        saveIn: image.save_in || 0,
        url,
        isActive: false
      } as MediaViewModel;
    });
  }

  private countHydrationHits(
    pending: Array<{ id: number; name: string; mediaIds: number[] }>,
    data: MediaViewModel[]
  ): number {
    const byId = new Set((data || []).map(item => Number(item.id)));
    return (pending || []).reduce(
      (sum, group) => sum + (group.mediaIds || []).filter(id => byId.has(Number(id))).length,
      0
    );
  }

  private applyHydratedCampaignGroups(
    pending: Array<{ id: number; name: string; mediaIds: number[] }>,
    data: MediaViewModel[],
    token: number
  ) {
    if (token !== this.campaignHydrateToken) {
      return;
    }

    const byId = new Map<number, MediaViewModel>();
    (data || []).forEach(item => {
      if (item && item.id != null) {
        byId.set(Number(item.id), item);
      }
    });

    this.photoGalleryGroups = (pending || []).map(group => ({
      id: group.id,
      name: group.name,
      items: (group.mediaIds || [])
        .map(id => byId.get(Number(id)))
        .filter(Boolean)
        .map(item => ({ ...item, isActive: false }))
    }));
    this.galleries = this.photoGalleryGroups.reduce((acc, g) => acc.concat(g.items), []);
    this.pendingCampaignGroups = null;
    this.useGroupedGalleries = true;
    this.updateSelectedValues();
    this.isGalleriesLoading = false;
    this.detector.detectChanges();
    this.addSelectedUploadsGroup(token);
  }

  /**
   * Picked media that is in none of the shown galleries (usually the
   * requester's own uploads) goes in a leading "Your uploads" group, so it
   * stays visible and can be unticked. Stock ids (negative) are never added.
   */
  private addSelectedUploadsGroup(token: number) {
    const shown = new Set(this.galleries.map(item => Number(item.id)));
    const missing = (this.selectedData || [])
      .map(id => Number(id))
      .filter(id => id > 0 && !shown.has(id));
    const companyId = this.resolveCompanyId();
    if (!missing.length || !companyId) {
      return;
    }
    const url = `/api/v3/companies/${companyId}/media/?selected=${encodeURIComponent(missing.join(','))}&page=1&limit=${missing.length}`;
    this.httpClient.get(url).subscribe((response: any) => {
      if (token !== this.campaignHydrateToken) {
        return;
      }
      const wanted = new Set(missing);
      const seen = new Set<number>();
      const items = this.mapCompanyMediaList(response).filter(item => {
        if (!wanted.has(item.id) || seen.has(item.id)) {
          return false;
        }
        seen.add(item.id);
        return true;
      });
      if (!items.length) {
        return;
      }
      const uploads = { id: StoryflowCardGalleryRequestComponent.UPLOADS_GROUP_ID, name: 'Your uploads', items };
      this.photoGalleryGroups = [uploads].concat(
        this.photoGalleryGroups.filter(group => group.id !== StoryflowCardGalleryRequestComponent.UPLOADS_GROUP_ID)
      );
      this.galleries = this.photoGalleryGroups.reduce((acc, g) => acc.concat(g.items), []);
      this.updateSelectedValues();
      this.detector.detectChanges();
    }, () => { });
  }

  private showEmptyFlatGallery() {
    this.currentLoadKey = null;
    this.lastLoadedCampaignId = null;
    this.pendingCampaignGroups = null;
    this.useGroupedGalleries = false;
    this.expectGalleryLoadResult = false;
    this.photoGalleryGroups = [];
    this.galleries = [];
    this.slots = [];
    this.isGalleriesLoading = false;
    this.detector.detectChanges();
  }

  private showEmptyCampaignGallery() {
    this.pendingCampaignGroups = null;
    this.useGroupedGalleries = true;
    this.photoGalleryGroups = [];
    this.galleries = [];
    this.isGalleriesLoading = false;
    this.detector.detectChanges();
  }

  private loadMedia() {
    // The media step subscription loads as soon as the gallery setting arrives.
    if (!this.galleryStateKnown) {
      return;
    }
    const companyId = this.resolveCompanyId();
    this.viewmodel.companyId = companyId;
    this.loadMediaInputData.companyId = companyId;
    const campaignId = this.resolveCampaignId();
    // Drop any in-flight grouped load or hydrate from a previous campaign/company.
    this.campaignHydrateToken++;
    this.cancelGroupedLoad();
    this.galleryLoadStarted = true;
    this.isGalleriesLoading = true;

    // Pixabay keyword search and the "gallery off" grid use the flat media list.
    const searchText = (this.loadMediaInputData.searchText || '').toString().trim();
    const searching = !!(this.loadMediaInputData.searchFrom && searchText);
    if (searching || !this.isGalleryActivated) {
      // Gallery off: only the user's own uploads are shown, so with nothing
      // selected there is nothing to fetch and the "upload" message shows.
      const hasUploads = !!(this.selectedData && this.selectedData.length);
      if (!searching && (!companyId || !hasUploads)) {
        this.showEmptyFlatGallery();
        return;
      }
      this.loadFlatMedia(companyId);
      return;
    }

    const loadKey = campaignId ? `campaign:${campaignId}` : `company:${companyId}`;
    if (loadKey !== this.currentLoadKey) {
      // Never leave another campaign's (or an earlier modal's) gallery on screen while loading.
      this.clearShownGallery();
    }
    this.currentLoadKey = loadKey;
    this.lastLoadedCampaignId = campaignId;
    this.expectGalleryLoadResult = false;
    this.useGroupedGalleries = true;

    // A campaign shows its attached galleries; otherwise the company default
    // galleries (Gallery source = Custom) or GoodSeeker stock (Default gallery).
    const request$ = campaignId
      ? this.photoGalleryHttpService.loadCampaignMediaGrouped(campaignId)
      : (companyId ? this.photoGalleryHttpService.loadCompanyMediaGrouped(companyId) : null);
    if (!request$) {
      this.showEmptyCampaignGallery();
      return;
    }

    this.groupedLoadSub = request$.subscribe((response) => {
      if (response && (response.mode === 'grouped' || response.mode === 'default')) {
        this.applyCampaignGroupedResponse(response.groups || []);
      } else {
        this.showEmptyCampaignGallery();
      }
    }, (err) => {
      // API without the company galleries endpoint yet: the company's own pool, never stock.
      if (!campaignId && err && err.status === 404) {
        this.loadFlatMedia(companyId);
        return;
      }
      this.showEmptyCampaignGallery();
    });
  }

  private loadFlatMedia(companyId: number) {
    this.currentLoadKey = null;
    this.lastLoadedCampaignId = null;
    this.pendingCampaignGroups = null;
    this.useGroupedGalleries = false;
    this.photoGalleryGroups = [];
    this.expectGalleryLoadResult = true;
    this.store$.dispatch(new mediaActions.Load(this.loadMediaInputData, companyId));
  }

  private cancelGroupedLoad() {
    if (this.groupedLoadSub) {
      this.groupedLoadSub.unsubscribe();
      this.groupedLoadSub = null;
    }
  }

  private clearShownGallery() {
    this.pendingCampaignGroups = null;
    this.photoGalleryGroups = [];
    this.galleries = [];
    this.slots = [];
    this.detector.detectChanges();
  }

  // getSelctedValues(id){

  
  // }

  getLocalStream() {
    // navigator.mediaDevices.getUserMedia({video: true, audio: true}).then( stream => {
    // }).catch( err => {
    //     //console.log("u got an error:" + err)
    // });
}
destroyLocalstream(){
//   window.streamReference.getAudioTracks().forEach(function(track) {
//     track.stop();
// });

// window.streamReference.getVideoTracks().forEach(function(track) {
//     track.stop();
// });
//   navigator.mediaDevices.getUserMedia({audio: false, video: true}).then( stream => {
//     var track = stream.getTracks()[0];  // if only one media track
//               // ...
//               track.stop();
//   }).catch( err => {
//       //console.log("u got an error:" + err)
//   });
}

  private updateSelectedValues() {
      // var selcted = this.form.get('media') as FormArray;
      // //console.log(selcted[0]
         this.galleries.forEach((item)=>{
          if(this.selectedData.includes(item.id)){
            item.isActive = true;
          }
          else{
            item.isActive = false;
          }
         });
         if (this.photoGalleryGroups && this.photoGalleryGroups.length) {
           this.photoGalleryGroups.forEach(group => {
             group.items.forEach((item) => {
               item.isActive = this.selectedData.includes(item.id);
             });
           });
         }

         this.galleries.sort((a, b) => Number(b.isActive) - Number(a.isActive));

         if(!this.isGalleryActivated){
          this.updateSlots();
         }
     
         
         //console.log(this.selectedData)
        //  if(this.selectedData.length){
        //   this.updateData();
        //   this.loadMediaInputData.selectedValues = this.selectedData
        //   this.loadMedia();
        //  }
       

      }


      updateSlots() {
        const mediaItems = [...this.galleries]; // clone
      
        const skeletonCount = Math.max(0, this.totalSlots - mediaItems.length);
      
        const skeletons = Array.from({ length: skeletonCount }, () => ({
          isSkeleton: true
        }));
      
        // Always: MEDIA FIRST + SKELETON BELOW
        this.slots = [...mediaItems, ...skeletons];
      }

  private initForm() {
    this.form = this.formBuilder.group({
      media: ['']
    });

    this.searchText = new UntypedFormControl();
    this.resultFrom = new UntypedFormControl('unsplash');
  }

get isMobile() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];
  const isAgentMobile = toMatch.some((toMatchItem) =>
    navigator.userAgent.match(toMatchItem)
  );

  // A large-screen Android device (e.g. Lenovo 32" 4K tablet)
  // reports ~1920px innerWidth — don't treat it as mobile
  return isAgentMobile && window.innerWidth <= 899;
}

  private initUploader() {
    let config = new UploaderConfig();
    // config.button = this.browseFileButton.toArray()[0].nativeElement;
    config.companyId = this.viewmodel.isInbound ? this.viewmodel.companyId : this.viewmodel.companyId;
    config.isAnonymous = this.inbound_builder;
    config.validate = {
      allowedExtensions: ['gif', 'jpeg', 'jpg', 'png', 'mp4', 'mpg', 'mov', '3gp', 'avi', 'flv', 'm4v', 'mkv', 'mpeg', 'mts', 'ogv', 'vob', 'webm']
    };
    config.messages = {
      imageDimensionError: 'Use a larger image - 640 x 480px minimum.',
      typeError: 'Acceptable file formats are gif, jpg, jpeg, png, mp4, mpg and mov.'
    };

    let callbacks = new Callback();
    callbacks.onSubmit = this.onUploaderSubmit.bind(this);
    callbacks.onComplete = this.onUploaderComplete.bind(this);
    callbacks.onError = this.onUploaderError.bind(this);
    callbacks.onProgress = this.onProgress.bind(this);
    callbacks.onAllComplete = this.onUploaderAllComplete.bind(this);

    this.uploader = this.uploaderService.s3Uploader(config, callbacks);
  }

  private createMedia(data: CreateMediaInputApiModel) {
    if(this.showIndicator){
      if(data.type == 'video/mp4'){
        this.uploaderViewModel.progressCss = 95+'%'
      }
      // this.store$.dispatch(new mediaActions.checkAssetReadyOrNot(true,'Uploading Complete',' 99.45673434%'))

      this.toastService.success("Video uploaded! It will be added to the story in a few minutes.");

    }

    this.store$.dispatch(new mediaActions.Create(this.viewmodel.isInbound ? this.viewmodel.companyId : this.viewmodel.companyId, data));
  }

  private onProgress(id: any, name: any, loaded: any, total: any) {
    const percent = (loaded / total) * 100;
    this.uploaderViewModel.isError = false;
    this.uploaderViewModel.progress = percent;
    this.uploaderViewModel.progressCss = `${percent}%`;
    this.detector.detectChanges();
  }

  private onUploaderSubmit(id) {
    if (!this.selectedUnsplashMedia) {
      this.uploaderViewModel.isUploading = true;
    }
    const uploadFile = this.uploader.getFile(id);
    if (uploadFile.type.indexOf('video') > -1) {
      // Custom video validate
      this.loadingPopupService.show();
      this.uploader.pauseUpload(id);
      this.utility.File.getVideoDuration(uploadFile).then((durationInSec) => {
        if (durationInSec > this.videoMaxDurationAccepted) {
          this.uploader.cancel(id);
          this.uploaderViewModel.isError = true;
          this.uploaderViewModel.errorMsg = `Keep your video length to ${this.videoMaxDurationAccepted} seconds.`;
          this.loadingPopupService.hide();
          this.toastService.error(this.uploaderViewModel.errorMsg);
        } else {
          this.uploader.retry(id);
        }
      });
    }
  }

  private onUploaderComplete(id: any, name: any, responseJSON: any, maybeXhr: any) {
    if (responseJSON.success) {
      let createMediaInputData = new CreateMediaInputApiModel();
      createMediaInputData.origname = name;
      createMediaInputData.size = this.uploader.getSize(id);
      const fileInfo = this.uploaderService.getUploadedFile(id);
      createMediaInputData.path = fileInfo.path;
      createMediaInputData.source = fileInfo.name;
      createMediaInputData.filename = fileInfo.name;
      createMediaInputData.type = fileInfo.type;
      createMediaInputData.video_token = null;
      createMediaInputData.story_id = this.storyData && this.storyData.id || 0;
      if(!this.isVideo(fileInfo.type)){
        this.mediaCreating = true;
        this.createMedia(createMediaInputData);
      }
      else{
        var url = 'https://goodseeker-staging-processed.s3.amazonaws.com/goodseeker'+fileInfo.path+'/'+fileInfo.name
       
        this.makeMuxApiRequest(url)
      }
    }
  }

  private onUploaderAllComplete() {
    this.uploaderViewModel.isUploading = false;
    this.uploaderViewModel.progress = 0;
    this.uploaderViewModel.progressCss = `0%`;
  }

  private onUploaderError(id: any, name: any, reason: any, maybeXhrOrXdr: any) {
    this.uploaderViewModel.isError = true;
    this.uploaderViewModel.errorMsg = reason;
  }

  private filterMediaByComp() {
    this.loadMediaInputData.isFilterByGlobal = false;
    this.loadMediaInputData.pagination.page = 1;
    this.loadMediaInputData.selectedValues = this.selectedData;
    this.loadMedia();
  }

  private filterMediaByGlob() {
    this.loadMediaInputData.isFilterByGlobal = true;
    this.loadMediaInputData.pagination.page = 1;
    
    this.loadMediaInputData.selectedValues = this.selectedData;
    this.loadMedia();
  }

  private filterMediaByTab(tabId) {
    const tabActiveItem = this.filterTabObj.items.find(f => f.id === tabId);
    tabActiveItem.filterFunc();
  }

  // Public funtions

  selectedUnsplashMedia: MediaViewModel;

  public selectItem(media?: MediaViewModel){
    var selctedData = [];
    
    this.mediaCreating = true;
    if (media && media.from && media.from === 'pixabay') {
      this.selectedUnsplashMedia = media;
      if(media.isActive){

        this.selectedData.push(media.id)
        this.remaningunsplashids.push(media.id)
        this.downloaded = true
         this.store$.dispatch(new mediaDownloadAction.CheckDownloaf(true))
      }
      else if(!media.isActive && (this.selectedData.indexOf(media.id) != -1)){
         this.selectedData = this.selectedData.filter(item => item != media.id)
         var newId = this.idhistory.find((item)=> item.oldid == media.id).newId;
         this.selectedData = this.selectedData.filter(item => item != newId)
         this.selectedUnsplashMedia = null
         this.remaningunsplashids = this.remaningunsplashids.filter(item => item != media.id)

      }

    } 
    else {
      if(media.isActive){
        this.selectedData.push(media.id)
      }
      else if(!media.isActive && this.selectedData.indexOf(media.id) != -1){
         this.selectedData = this.selectedData.filter(item => item != media.id)
      }
      this.selectedUnsplashMedia = null;
    }
    if (this.selectedUnsplashMedia) {
      this.uploaderViewModel.isUploading = true;
      this.getBase64ImageFromUrl(this.selectedUnsplashMedia.fullsize)
        .then((result: any) => {
          const imageEditedBlob = this.utility.File.b64ToBlob(result.replace(/^data:(image|binary)\/[^;]+;base64,/, ''), this.selectedUnsplashMedia.type);
          // Old file       const imageEditedBlob = this.utility.File.b64ToBlob(result.replace(/^data:image\/(png|jpeg|jpg|avif|octet-stream|webp|heic);base64,/, ''), "image/png");
          imageEditedBlob['path'] = 'story-image';
          this.uploader.addBlobs(imageEditedBlob);
        })
        .catch(err => console.error(err));
    }
    this.updateData();
  }

  public onPositionChanged() {
    this.viewmodel.scrollbarVisible = true;
  }

  public scrollReachEnd() {
    // Grouped galleries arrive in one response; only the flat list pages.
    if (this.useGroupedGalleries) {
      return;
    }
    if (this.loadMore && this.viewmodel.scrollbarVisible) {
      this.loadMediaInputData.pagination.page += 1;
      this.loadMediaInputData.selectedValues = this.selectedData && this.selectedData.length ? this.selectedData : [];
      this.loadMedia();
    }
  }

  public galleriesTrackByFnc(item) {
    return item.id;
  }

  public updateData() {
    
    if (!this.stepActive) return;
    if(this.selectedData.length){
      this.dynamicObject= {16 : this.selectedData}
      this.store$.dispatch(new storyStepActions.AddMediaObject(this.dynamicObject))
      this.store$.dispatch(new storyBuilderActions.UpdateStoryStepSelected(this.stepActive.id, this.selectedData));
    }
    else{
      this.dynamicObject= {16 : this.selectedData}
      this.store$.dispatch(new storyStepActions.AddMediaObject(this.dynamicObject))
      this.store$.dispatch(new storyBuilderActions.UpdateStoryStepSelected(this.stepActive.id, []));
    }



    // this.store$.dispatch(new mediaActions.MediaHistory(this.selectedData));
    
  }

  public showRecorder() {
    this.hideSearchBar();
    const uA = navigator.userAgent;
    const vendor = navigator.vendor;
    if (/Safari/i.test(uA) && /Apple Computer/.test(vendor) && !/Mobi|Android/i.test(uA)) {
      this.toastService.info("Video recording is not supported in this browser. Please try on chrome!");
    } else {
      this.isShowRecorder = true;
      this.isCamera = true;
    }
  }

  public isVideo(type) {
    return type && type.indexOf('video') > -1;
  }

  public handleComKeyEnter() {
    const isCompleted = this.selectedData && this.selectedData.length > 0;
    if (isCompleted) {
      // Goto next step
      this.store$.dispatch(new storyBuilderActions.GotoNextStep());
    }
  }

  public tabItemClick(tabId: number) {
    if (this.filterTabObj.tabActive === tabId) return;
    this.filterTabObj.tabActive = tabId;
    this.filterMediaByTab(tabId)
  }

  uploadDATA(data){
    if(!this.isBrowser) return;
    this.mediaCreating = true;
    if(data.target.files && data.target.files.length && data.target.files[0].type.includes("image")){
      this.getBase64ImageFromImages(data.target.files[0]).then((res: any) => {  
        const imageEditedBlob = this.utility.File.b64ToBlob(res.replace(/^data:(image|binary)\/[^;]+;base64,/, ''), "image/png");
        imageEditedBlob['path'] = 'story-image';
        this.uploader.addBlobs(imageEditedBlob);
      })
    }
    else{
      const videoFile = data.target.files[0];
      const sizeGuard = inspectVideoUploadSize(videoFile?.size, { mobile: this.isSmallScreen });
      if (!sizeGuard.allowed) {
        this.mediaCreating = false;
        this.toastService.error(sizeGuard.message);
        return;
      }
      void this.beginCameraRollUpload(data, videoFile, sizeGuard);

  
    }


    // this.storyHttpService.pollApiUntilReady(self.viewmodel.companyId,payload).subscribe((res)=>{
    //   const uploadUrl = res.url 
    //   uploadId = res.id
    //   return uploadUrl;
    // })

  }
  private async beginCameraRollUpload(data, videoFile: File, sizeGuard: { warn: boolean; message: string }) {
    let fileToSend = videoFile;
    const wakeLock = new ScreenWakeLock();
    if (shouldShrinkMobileVideo(videoFile?.size, this.isSmallScreen)) {
      this.uploaderViewModel.isUploading = true;
      this.toastService.warning('Preparing a smaller copy so it sends faster. Keep this screen on.');
      await wakeLock.acquire();
      try {
        fileToSend = await shrinkMobileCameraRoll(videoFile, { mobile: true });
      } finally {
        await wakeLock.release();
      }
    }
    const afterShrink = inspectVideoUploadSize(fileToSend?.size, { mobile: this.isSmallScreen });
    if (afterShrink.warn) {
      this.toastService.warning(afterShrink.message);
    } else if (sizeGuard.warn && !this.isSmallScreen) {
      this.toastService.warning(sizeGuard.message);
    }
    this.cameraRollFile = fileToSend;
    this.uploaderViewModel.isUploading = true;
    this.normalFile = data;
    this.commonUploadFuctionality();
  }

  cancelFile(){
    this.fileInput.nativeElement.value = ''; 
  }


  public onRecordFinish(recorderData: any) {
    this.downloaded = true
    this.mediaCreating = true
    this.store$.dispatch(new mediaDownloadAction.CheckDownloaf(true))
    this.isShowRecorder = false;
    if (recorderData) {
      this.isShowRecorder = false;
      // To upload recorder file
      // recorderData['path'] = 'story-video';
     if(recorderData.isPhoto){
      const imageEditedBlob = this.utility.File.b64ToBlob(recorderData.blobcontent.replace(/^data:(image|binary)\/[^;]+;base64,/, ''), 'image/png');
      imageEditedBlob['path'] = 'story-image';
      this.uploader.addBlobs(imageEditedBlob);
     }
     else{
      this.store$.dispatch(new mediaRecordAction.CheckRecord(true));
      // recorderData.blobcontent['path'] = 'story-video';
      const muxUploader:any = document.getElementById("my-uploader-gs");
      if (muxUploader) {
        muxUploader.dynamicChunkSize = true;
      }
      var uploadIdDv;
      const self = this;
      // Dispatch custom event to trigger upload
      // let file = this.blobToFile(recorderData.blobcontent,'video.mp4')
      const fileName = 'example.mp4'; // Replace with your desired filename
      const file = new File([recorderData], fileName, { type: recorderData.type });
      //console.log(">>",file)

      muxUploader.endpoint = async () => {
        const payload = {
          origin:window.location.origin
        }
       
         const uploadUrl = await this.storyHttpService.pollApiUntilReady(this.companyID,payload).toPromise();
         uploadIdDv = uploadUrl.id
        return uploadUrl.url
  
      }
      // //console.log(">>",data.target.files[0])
      muxUploader.dispatchEvent(
        new CustomEvent("file-ready", {
          composed: true,
          bubbles: true,
          detail: file
        })
      )
      muxUploader.addEventListener("progress", function (e: any) {
        //console.log(`My upload is ${e.detail}% complete!`);
         let progessCss= Math.trunc(e.detail);
         self.uploaderViewModel.isUploading = true;
         if(progessCss != 100){
           self.uploaderViewModel.progressCss = progessCss+'%';
          //  self.store$.dispatch(new mediaActions.checkAssetReadyOrNot(true,'Uploading',progessCss+'%'))
         }

         if(progessCss == 100){
          self.uploaderViewModel.progressCss = 80+'%';
          // self.store$.dispatch(new mediaActions.checkAssetReadyOrNot(true,'Uploading in progress','99.9506%'))
          // self.uploaderViewModel.isUploading = false;
          // self.makeMuxApiRequest(uploadId)
         }
      });
          muxUploader.addEventListener("success", function (e: any) {
            self.makeMuxApiRequest(uploadIdDv)
      });
     }
    
    }
  }

  public blobToFile = (theBlob: Blob, fileName:string): File => {
    const b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;
      
    //Cast to a File() type
    return theBlob as File;
  }

  public onRecorderClose() {
    this.isShowRecorder = false;
  }

  showSearchBar(): void {
    this.searchBarVisible = true;
    setTimeout(() => {
      document.getElementById("searchUnsplash").focus();
    }, 100);
  }


  hideSearchBar(): void {
    this.searchBarVisible = false;
    this.searchText.setValue(null);
    this.selectedUnsplashMedia = null;
    this.loadMediaInputData = null;
    this.loadMediaInputData = new LoadMediaInputApiModel(new PaginationModel(30));
    if(this.remaningunsplashids.length){
      
      this.selectedData = this.selectedData.filter(item => !this.remaningunsplashids.includes(item));
      this.totalDatainmedai = this.selectedData.length
      this.remaningunsplashids = [];
      this.dynamicObject= {16 : this.selectedData}
      this.store$.dispatch(new storyStepActions.AddMediaObject(this.dynamicObject))
      this.store$.dispatch(new storyBuilderActions.UpdateStoryStepSelected(this.stepActive.id, this.selectedData));

    }
    this.filterMediaByGlob();
  }

  async getBase64ImageFromUrl(imageUrl) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();

    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }




  // startRecording(){
  //   //   this.isVideoCapture = true;
  // //   this.defaultOptionMenu = false;
  // //   // this.hideForVideo = false;
  // // // this.modalService.showModal(VideoEditorModalComponent, null, { class: 'modal-lg' }).then(() => {
  // // // });
  // // $("#hippo-scripts").empty();
  // //   let hippoDigest =  'oK9OMC26BUZwGMlgje4e0Q0XQNuiWoBDl4hgj79H3Hk'; //Paste your digest here
  // //   let injectScript = document.createElement('script');
  // //   injectScript.type = 'text/javascript';
  // //   injectScript.async = false;
  // //   injectScript.innerHTML = 'var s = document.createElement("script"); s.src = "https://s3.amazonaws.com/hippovideo-embed-widget/js/hippovideo-embed-script.js";window.setDigestOnStart = true;s.async = true;window.hippovideoDigest = "' + hippoDigest + '";window.hvintegtype = "generic_embed";window.hippoWidget={loadedCallbacks:[],isLoaded:false,onLoad: function(callback){if(window.hippoWidget.isLoaded==true)callback();else window.hippoWidget.loadedCallbacks.push(callback);}}; document.getElementById("hippo-scripts").appendChild(s);'
  // //   document.getElementById('hippo-scripts').appendChild(injectScript);
  //   // this.HipporecordFunction();
  //   window.hippoWidget.onLoad(function () {
  //     //console.log('Hippo widget loaded.....');

  //     var recordingConfiguration = {
  //       // screenRecord: false,
  //       // audio: true,
  //       // webCam: true,
  //       // systemAudio: true,
  //       // resolution: "720",
  //       // separateLayer: false,
  //       // showAdvancedOptions: true,
  //       audio: true,
  // // description: "Personalize the intro by calling your prospects name.",// remove
  // // fromPopup: true, //remove
  // // from_product_review: true,//remove
  // // initiator: "generic_embed",//remove
  // // my_video: true,//remove
  // resolution: "720",
  // screenRecord: false,
  // separateLayer: false,
  // showAdvancedOptions: true,
  // initiator: "generic_embed",
  // recordTime:record_time,
  // showFaceCue: true,
  // showPreview: true,
  // systemAudio: false,
  // // tabRecording: false,
  // webCam: true,
  // // webcamBitRate: 7000,


  //     };

  //     window.hippoWidget.startRecording(recordingConfiguration);


  //     window.hippoWidget.on("record_initiated", function (event: any) {
  //       //console.log("recording initiated", event);
  //       record_token = event;

  //     });
  //     window.hippoWidget.on("video_submitted", function (event: any) {
  //       //console.log("recording submitted", event);
  //       submitteed = true;
  //       document.getElementById("import-record-hippo-complete").click();
  //       // document.getElementById("close_video_modal").click();
  //       // $("#hippo-scripts").empty();
        
  //     });


  //     window.hippoWidget.on("record_aborted", function (event: any) {
  //       //console.log("recording aborted", event);
  //       submitteed = false;
  //       // document.getElementById("close_video_modal").click();
  //       // $("#hippo-scripts").empty();

  //     });
  //   });
  // // this.modalService.showModal(VideoEditorModalComponent, null, { class: 'modal-lg-s', backdrop: false }).then((data) => {
  // //   if(data){
  // //     // this.store$.dispatch(new storyBuilderActions.UpdateStoryStepSelected(this.stepActive.id, this.selectedData));
  // //     let createMediaInputData = new CreateMediaInputApiModel();
  // //     createMediaInputData.origname = 'hippo';
  // //     createMediaInputData.size = 34565;
  // //     const fileInfo = data.token;
  // //     createMediaInputData.path = data.token;
  // //     createMediaInputData.source = data.token;
  // //     createMediaInputData.filename = data.token+'.jpg';
  // //     createMediaInputData.type = 'video/mp4';
  // //     createMediaInputData.story_id = this.storyData && this.storyData.id || 0;
  // //     this.createMedia(createMediaInputData);
  // //   }
  // // });
  //   // let hippoDigest =  'oK9OMC26BUZwGMlgje4e0Q0XQNuiWoBDl4hgj79H3Hk'; //Paste your digest here
  //   // let injectScript = document.createElement('script');
  //   // injectScript.type = 'text/javascript';
  //   // injectScript.async = false;
  //   // injectScript.innerHTML = 'var s = document.createElement("script"); s.src = "https://s3.amazonaws.com/hippovideo-embed-widget/js/hippovideo-embed-script.js";window.setDigestOnStart = true;s.async = true;window.hippovideoDigest = "' + hippoDigest + '";window.hvintegtype = "generic_embed";window.hippoWidget={loadedCallbacks:[],isLoaded:false,onLoad: function(callback){if(window.hippoWidget.isLoaded==true)callback();else window.hippoWidget.loadedCallbacks.push(callback);}};document.head.appendChild(s);'
  //   // document.getElementsByTagName('head')[0].appendChild(injectScript);
  //   //   this.startRecordings();
  // }


  // importVideo(){
  //   // this.hideForVideo = false;
  // // this.modalService.showModal(VideoEditorModalComponent, null, { class: 'modal-lg' }).then(() => {
  // // });

  //   // this.startImport();
  //   window.hippoWidget.onLoad(function () {
  //     //console.log('Hippo widget loaded.....');
  
    
  
  //     window.hippoWidget.import();
  //     // window.hippoWidget.import();
  
  
  //     window.hippoWidget.on("record_initiated", function (event: any) {
  //       //console.log("recording initiated", event);
  //       // record_token = event;
  
  //     });
  //     window.hippoWidget.on("video_submitted", function (event: any) {
  //       //console.log("recording submitted", event);
  //       submitteed = true;
  //       document.getElementById("import-record-hippo-complete").click();
    
  //     });
  
  
  //     window.hippoWidget.on("record_aborted", function (event: any) {
  //       //console.log("recording aborted", event);
  //       submitteed = false;
       
  
  //     });
  
  //     window.hippoWidget.on("import_progress", function (event: any) {
  
  //       // //console.log("import_progress", event);
  //     });
    
  //     window.hippoWidget.on("import_complete", function (event: any) {
  //       // //console.log("import_complete", event);
  //       record_token = event;
  //     });
    
  //     window.hippoWidget.on("import_failed", function (event: any) {
  //       // //console.log("import_failed", event);
  //     });
    
  //     window.hippoWidget.on("source_uploaded", function (event: any){
  //       // //console.log("source_uploaded", event);
  //     });
  //   });
  // //  this.modalService.showModal(ImageUploderModalComponent, null, { class: 'modal-lg-s', backdrop: false }).then((data) => {
  // //   if(data){
  // //     // this.store$.dispatch(new storyBuilderActions.UpdateStoryStepSelected(this.stepActive.id, this.selectedData));
  // //     let createMediaInputData = new CreateMediaInputApiModel();
  // //     createMediaInputData.origname = 'hippo';
  // //     createMediaInputData.size = 34565;
  // //     const fileInfo = data.token;
  // //     createMediaInputData.path = data.token;
  // //     createMediaInputData.source = data.token;
  // //     createMediaInputData.filename = data.token+'.jpg';
  // //     createMediaInputData.type = 'video/mp4';
  // //     createMediaInputData.story_id = this.storyData && this.storyData.id || 0;
  // //     this.createMedia(createMediaInputData);
  // //   }
  // // });
  //   // let hippoDigest =  'oK9OMC26BUZwGMlgje4e0Q0XQNuiWoBDl4hgj79H3Hk'; //Paste your digest here
  //   // let injectScript = document.createElement('script');
  //   // injectScript.type = 'text/javascript';
  //   // injectScript.async = false;
  //   // injectScript.innerHTML = 'var s = document.createElement("script"); s.src = "https://s3.amazonaws.com/hippovideo-embed-widget/js/hippovideo-embed-script.js";window.setDigestOnStart = true;s.async = true;window.hippovideoDigest = "' + hippoDigest + '";window.hvintegtype = "generic_embed";window.hippoWidget={loadedCallbacks:[],isLoaded:false,onLoad: function(callback){if(window.hippoWidget.isLoaded==true)callback();else window.hippoWidget.loadedCallbacks.push(callback);}};document.head.appendChild(s);'
  //   // document.getElementsByTagName('head')[0].appendChild(injectScript);
  //   //   this.startRecordings();



  // }



  startRecording() {
    if(this.loadMediaInputData.pagination.page > 1 || this.searchText.value){
      this.hideSearchBar();
    }
    this.store$.dispatch(new mediaRecordAction.CheckRecord(true))
    // recordData.open();
    // this.isShowRecorder = true;
    // this.isCamera = false;
    let data = {
      storyParam :this.storyParam,
      questionModels:this.questionModels,
      showPreviousNextButton:this.showPreviousNextButton,
      currentCompany :this.currentCompany,
      interViewStyle:this.interviewStyle,
      isPreview:this.isPreview,      
      companyID: this.viewmodel.companyId,
      inbound_builder: this.inbound_builder,
      videoduration: this.videoduration  ? this.videoduration * 60 : 180
    }

    // this.modalService.showModal(VideoRecorderMediaComponent ,data, {class:'modal-lg-video'}).then((data)=>{

    //   if(data){
    //     this.onRecordFinish(data.blobcontent)
    //     if(data.campaignDetail){
    //       this.campaIgnDetail(data.campaignDetail)
    //     }
    //   }
    // })

    // let initializeOptions = {token: }
    // const onVideoSdkInitialize = (data, error) => { if(data)
    //   const recorder = RecorderWidget.create(data.key, config);
    //   //add eventListeners
    //   }
    // Initialize(initializeOptions, onVideoSdkInitialize);
    //   this.isVideoCapture = true;
    //   this.defaultOptionMenu = false;
    //   // this.hideForVideo = false;
    // // this.modalService.showModal(VideoEditorModalComponent, null, { class: 'modal-lg' }).then(() => {
    // // });
    // $("#hippo-scripts").empty();
    //   let hippoDigest =  'oK9OMC26BUZwGMlgje4e0Q0XQNuiWoBDl4hgj79H3Hk'; //Paste your digest here
    //   let injectScript = document.createElement('script');
    //   injectScript.type = 'text/javascript';
    //   injectScript.async = false;
    //   injectScript.innerHTML = 'var s = document.createElement("script"); s.src = "https://s3.amazonaws.com/hippovideo-embed-widget/js/hippovideo-embed-script.js";window.setDigestOnStart = true;s.async = true;window.hippovideoDigest = "' + hippoDigest + '";window.hvintegtype = "generic_embed";window.hippoWidget={loadedCallbacks:[],isLoaded:false,onLoad: function(callback){if(window.hippoWidget.isLoaded==true)callback();else window.hippoWidget.loadedCallbacks.push(callback);}}; document.getElementById("hippo-scripts").appendChild(s);'

  }

  campaIgnDetail(data){
this.campaignDetailAction.emit(data)
  }

  showNextUploadMessage(isUploadComplete,currentProgress) {
    if (isUploadComplete || currentProgress >= 100) return;
    if (currentProgress > 90) {
      this.uploadMessages.push("Uploading near complete.");
      // return;
    }
  
    // Occasionally show "Big file..." if progress is far behind
    if (!isUploadComplete) {
      // this.toasterService.success(this.uploadMessages[this.messageIndex]);
      this.notifymessage = this.uploadMessages[this.messageIndex];
      this.toastService.success(this.notifymessage)
     this.messageIndex = (this.messageIndex + 1) % this.uploadMessages.length;

    } 
  
    this.bigFileReminderCounter++;
  }
  commonUploadFuctionality(){
    // this.downloaded = true
    const self = this;
    var uploadId:any;
    this.store$.dispatch(new mediaDownloadAction.CheckDownloaf(true))
    const muxUploader:any = document.getElementById("my-uploader-gs");
    if (muxUploader) {
      muxUploader.dynamicChunkSize = true;
    }

let uploadStartTimeout: any;
let uploadWarningInterval: any;
let isUploadComplete = false;
let currentProgress = 0;
    this.uploaderInstance = muxUploader;
    // ['uploadstart'].forEach(evt => {
    //   muxUploader.addEventListener(evt, (e) => {
    //     console.log(`📦 Event: ${evt}`, e);
    //   });
    // });
    muxUploader.addEventListener("uploadstart", function () {
      isUploadComplete = false;
      currentProgress = 0;
      self.messageIndex = 0;
      self.bigFileReminderCounter = 0;
      // Start 1-minute timer
      uploadStartTimeout = setTimeout(() => {
        if (!isUploadComplete && currentProgress < 100) {
          // Show first toaster after 1 minute
        self.notificationProcess = true;
         self.notifymessage =  "Export done. Commence uploading…";
         self.toastService.success(self.notifymessage)  
          // Then repeat every 5 seconds
          uploadWarningInterval = setInterval(() => {
            if (!isUploadComplete && currentProgress < 100) {
              self.showNextUploadMessage(isUploadComplete,currentProgress);
              // self.toasterService.warning("Upload still in progress...");
              // self.showNextUploadMessage(isUploadComplete,currentProgress);

            }

          }, 5000);
        }
      }, 10000);

      setTimeout(() => {
        if (!isUploadComplete && currentProgress < 100 ) {
          self.uploadMessages.push("Big file. Just a bit longer.");
        }
      }, 45000);
    });
    muxUploader.endpoint = async () => {
      const payload = {
        origin:window.location.origin
      }

      let cId = this.companyID;
      let companyId = +cId;
     
       const uploadUrl = await this.storyHttpService.pollApiUntilReady(companyId ? companyId : this.companyID,payload).toPromise();
       uploadId = uploadUrl.id
      return uploadUrl.url

    }
    //console.log(">>",this.normalFile.target.files[0])
  
    muxUploader.dispatchEvent(
      new CustomEvent("file-ready", {
        composed: true,
        bubbles: true,
        detail: this.cameraRollFile || this.normalFile.target.files[0],
      })
    )
    muxUploader.addEventListener("progress", function (e: any) {
      //console.log(`My upload is ${e.detail}% complete!`);
      

       let progessCss= Math.trunc(e.detail);
       currentProgress = progessCss;

       self.uploaderViewModel.isUploading = true;
       self.uploaderViewModel.progress = progessCss
       self.uploaderViewModel.progressCss = progessCss

       if(progessCss > 0 && progessCss < 2){
        
       }
       if(progessCss != 100){
          // muxUploader.cancel();
         self.uploaderViewModel.progressCss = progessCss+'%';
        //  self.store$.dispatch(new mediaActions.checkAssetReadyOrNot(true,'Uploading',progessCss+'%'))
       }


       if(progessCss == 100){

        self.uploaderViewModel.isUploading = false;
        self.uploaderViewModel.progress = '0%'
        self.uploaderViewModel.progressCss = '0%'

        isUploadComplete = true;
        clearTimeout(uploadStartTimeout);
        clearInterval(uploadWarningInterval);
        // self.store$.dispatch(new mediaActions.checkAssetReadyOrNot(true,'Uploading in progress','99.9506%'))
        // self.uploaderViewModel.isUploading = false;
        self.uploaderViewModel.progressCss = 90+'%';
        // self.makeMuxApiRequest(uploadId)
       }
 
    });



    muxUploader.addEventListener("success", function (e: any) {
      self.uploaderViewModel.progressCss = 87+'%'
      self.makeMuxApiRequest(uploadId)
      self.uploadMessages =[
        "Uploading in the works.",
        "Still doing its thing."
        ];
      clearTimeout(uploadStartTimeout);
      clearInterval(uploadWarningInterval);
});

muxUploader.addEventListener('uploaderror', function (e: any) {
  self.toastService.error(`Check connection${e.detail.message};`)
  // muxUploader.reset();
//   muxUploader.setAttribute('endpoint', ''); // force re-evaluation of endpoint function
// muxUploader.removeAttribute('value'); 
self.uploadMessages =[
  "Uploading in the works.",
  "Still doing its thing."
  ];
self.removeUpload();
  clearTimeout(uploadStartTimeout);
  clearInterval(uploadWarningInterval);
});

const onPageLeave = () => {
  if (muxUploader && muxUploader.abort) {
    muxUploader.abort(); // Use Mux's abort method
  }
; // Cancel any pending fetch requests
  //console.log('Upload canceled due to page leave');
};
  }


  removeUpload(){
    this.store$.dispatch(new mediaDownloadAction.CheckDownloaf(false))
    const muxUploader:any = document.getElementById("my-uploader-gs");

    muxUploader.dispatchEvent(new CustomEvent('reset'));

    // document.getElementById('cancelfle').click();

  }

  uploadMobileSocialMediaVideo(data){
    this.getBase64ImageFromImages(data.target.files[0]).then((res: any) => {  
      const imageEditedBlob = this.utility.File.b64ToBlob(res.replace(/^data:(image|binary)\/[^;]+;base64,/, ''), 'video/mp4');
      imageEditedBlob['path'] = 'story-video';
      this.uploader.addBlobs(imageEditedBlob);
    })
   }
 

 


   
  
  getUrl(media){
 
     return 'https://image.mux.com/'+media.source+'/thumbnail.jpg'
  
 
  }

  private tileReadyIds = new Set<number>();
  private tileFailedIds = new Set<number>();
  private tileOriginalTried = new Set<number>();

  /** Grid tiles use a small CDN variant. Selection still stores the media id. */
  public tilePreview(item: any): string | null {
    if (!item) {
      return null;
    }
    const url = galleryThumbnailUrl(this.originalTileUrl(item));
    if (!url || url === 'undefined' || url === 'null') {
      return null;
    }
    if (!/^https?:\/\//i.test(url) && !url.startsWith('data:') && !url.startsWith('blob:')) {
      return null;
    }
    return url;
  }

  public tileStatus(item: any): 'loading' | 'ready' | 'failed' {
    const id = item && item.id;
    if (id == null) {
      return 'loading';
    }
    if (this.tileFailedIds.has(id)) {
      return 'failed';
    }
    if (this.tileReadyIds.has(id)) {
      return 'ready';
    }
    return 'loading';
  }

  public onTileLoad(item: any): void {
    const id = item && item.id;
    if (id == null) {
      return;
    }
    this.tileFailedIds.delete(id);
    this.tileReadyIds.add(id);
  }

  public onTileError(item: any, event: Event): void {
    const img = event && event.target as HTMLImageElement;
    const id = item && item.id;
    if (!img || id == null) {
      return;
    }
    const original = this.originalTileUrl(item);
    if (original && !this.tileOriginalTried.has(id) && img.src !== original) {
      this.tileOriginalTried.add(id);
      img.src = original;
      return;
    }
    this.tileReadyIds.delete(id);
    this.tileFailedIds.add(id);
  }

  private originalTileUrl(item: any): string {
    if (!item) {
      return '';
    }
    if (this.isVideo(item.type)) {
      return item.thumbnail_url || this.getUrl(item);
    }
    return item.preview || item.url || item.fullsize || '';
  }

  designCanva() {
    if(this.isBrowser){
      const self = this;
      (function (document, url) {
        var script = document.createElement('script');
        script.src = url;
        script.onload = async function () {
          if (window.Canva && window.Canva.DesignButton) {
            const api = await window.Canva.DesignButton.initialize({
              apiKey: 'e2sw-EOGREFYSFClYlIU87eS',
            });
            window.api = api;
            setTimeout(() => {
              window.api.createDesign({
                design: {
                  type: 'Card',
                },
                onDesignPublish: ({ exportUrl, designId }) => {
                  self.getBase64ImageFromUrl(exportUrl)
                    .then((result: any) => {
                      const imageEditedBlob = self.utility.File.b64ToBlob(result.replace(/^data:(image|binary)\/[^;]+;base64,/, ''), "image/png");
                      imageEditedBlob['path'] = 'story-image';
                      self.uploader.addBlobs(imageEditedBlob);
                    })
                    .catch(err => console.error(err));
                }
              });
            }, 2000);
          }
        }
        document.body.appendChild(script);
      })(document, 'https://sdk.canva.com/designbutton/v2/api.js');
    }


  }

  getEditor(){
    // this.transformOptions = {
    //   resize: {
    //     width: 400
    //   },
    //   sepia: {
    //     tone: 80
    //   }
    // };
    // const client = filestack.init('AIy57QG1vQBWV83hkxEHEz').transform('https://ik.imagekit.io/lpzxd7bmi/goodseeker/pre/mediafiles/0/stories/209_uX7nAwW5GRxs.jpg?tr=n-full_siz',this.transformOptions)
  }

  HipporecordFunction(){


  }
  startImport(){
    $("#hippo-scripts").empty();

  }

    uplpadImageAndVideo(data){
     this.hideSearchBar();
     this.mediaCreating = true;
    if(data.target.files && data.target.files.length && data.target.files[0].type.includes("image")){
      this.getBase64ImageFromImages(data.target.files[0]).then((res: any) => {  
        const imageEditedBlob = this.utility.File.b64ToBlob(res.replace(/^data:(image|binary)\/[^;]+;base64,/, ''), "image/png");
        imageEditedBlob['path'] = 'story-image';
        this.uploader.addBlobs(imageEditedBlob);
      })
    }
    else{
       this.uploadDATA(data);
    }

  }



 async getBase64ImageFromImages(imageUrl) {
    // var res = await fetch(imageUrl);
    // var blob = await imageUrl.blob();

    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(imageUrl);
    })
  }
  


  importComplete(record_token){
  
      let createMediaInputData = new CreateMediaInputApiModel();
      createMediaInputData.origname = 'mux';
      createMediaInputData.size = 34565;
      const fileInfo = record_token.token;
      createMediaInputData.path = '';
      createMediaInputData.tags = record_token.token;
      createMediaInputData.source = '';
      createMediaInputData.filename = '';
      createMediaInputData.asset_id = record_token.asset_id
      createMediaInputData.type = 'video/mp4';
      createMediaInputData.url = record_token.url
      createMediaInputData.aspect_ratio = '';
      createMediaInputData.story_id = this.storyData && this.storyData.id || 0;
      this.createMedia(createMediaInputData);
    
     
  }

  makeMuxApiRequest(id): void {
    this.showIndicator = true;
    if(!this.uploadedId.length){
      this.uploadedId.push(id);
      this.makeAPiRequest(id);
    }
    if(this.uploadedId.length){
      let index = this.uploadedId.findIndex(item => item == id);
      if(index>=0){
        return
      }
      else{
        this.uploadedId.push(id)
        this.makeAPiRequest(id);
      }
    }

  }

  makeAPiRequest(id){
    this.storyHttpService.CheckpollApiUntilReady(id,this.viewmodel.companyId)
    .subscribe(
      (response: any) => {
        //console.log('Success:', response);
        // this.store$.dispatch(new mediaActions.checkAssetReadyOrNot(true,'Almost Complete','99.9506%'))
        this.uploaderViewModel.progressCss = 90+'%'
        let record = {
          token:id,
          asset_id:response,
          url:'',
          aspect_ratio:''
        }
        this.uploaderViewModel.progressCss = 95+'%'
            this.importComplete(record)
    
        // Handle the successful response here
      },
      (error) => {
        console.error('Error:', error);
        // Handle the error here
      }
    );
  }
  recordingComplte(){
  //   const apiUrl = 'https://api.mux.com/video/v1/assets?limit=1000';
  //  const  MUX_TOKEN_ID = 'e487e1f9-c9fe-4824-aedd-702362733722'
  //  const MUX_TOKEN_SECRET = '43uR7MzVZ4ysTiINeEb4/skmB9BcFHJYwMJXCbPmuif8JLU10fNqSGa2ktzIzHu4HrsbqSleC5k'
  //   const credentials = btoa(`${MUX_TOKEN_ID}:${MUX_TOKEN_SECRET}`); // Base64 encode the credentials
  // var deleteAPi = 'https://api.mux.com/video/v1/assets'
  //   // Set up the headers with Authorization
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Authorization': `Basic ${credentials}`
  //   });
  
  //   // Make the GET request
  //   this.httpClient.get(apiUrl, { headers: headers })
  //     .subscribe(
  //       (response:any) => {
  //         //console.log('API Response:', response);
  //         this.mapId = response.data.map((item)=> item.id);
        
  //         this.mapId.forEach((item)=>{
  //           let path = 
  //           this.httpClient.delete(deleteAPi+'/'+item,{ headers: headers }).subscribe((res)=>{})
  //         })
  //         // Handle the response data here
  //       },
  //       (error) => {
  //         console.error('API Error:', error);
  //         // Handle the error here
  //       }
  //     );
  }
  getextension(data) : string {
    let str = ''
    if(data.length == 1){
      str+='/low.mp4'
    }
    if(data.length == 2){
      str+='/medium.mp4'
    }
    if(data.length == 3){
      str+='/high.mp4'
    }
    return str;

  }
  triggerFileInput(){
    this.fileInput.nativeElement.click();
  }
  triggerMobileFileInput(){
    this.mobilefileInput.nativeElement.click();
  }

  active($event, stepid:any){
    $event.stopPropagation(); 
    this.store$.dispatch(new storyBuilderActions.GotoStep(stepid));
  }

  activeTag($event){
    let firsttagIndex = this.storyflowMenu.filter(item => item.id != 5 && item.id != 16)
    $event.stopPropagation(); 
    this.store$.dispatch(new storyBuilderActions.GotoStep(firsttagIndex[0].id));
  }

  public async uploadCloud() {   
    if(!this.isBrowser) return;

    const uploader = document.querySelector('.uploader-hidden');
    if (uploader) {
      uploader.classList.remove('uploader-hidden');
    }

    const simpleBtn = document.querySelector('uc-simple-btn');
    if (!simpleBtn) return;

    if (this.apiCollection) {
      this.apiCollection.removeAllFiles();
    }

    const realButton = simpleBtn.querySelector('button');
    if (realButton) {
      realButton.click();
    }
  }




  /** Upload from Phone: the widget source plus the inline QR panel share this context. */
  public get phoneUploadContext(): PhoneUploadContext {
    const companyId = Number(this.viewmodel.companyId) || 0;
    const storyId = (this.storyData && this.storyData.id) || 0;
    const cached = this.phoneUploadContextCache;
    if (!cached || cached.companyId !== companyId || cached.storyId !== storyId) {
      this.phoneUploadContextCache = { companyId, storyId, context: 'request-story-gallery', maxFiles: PHONE_UPLOAD_MAX_FILES, accept: STORY_MEDIA_ACCEPT };
    }
    return this.phoneUploadContextCache;
  }

  public get showPhoneUpload(): boolean {
    return this.isBrowser && !this.isSmallScreen && !this.isMobile;
  }

  /** Phone files enter the Uploadcare list by UUID, one at a time, so file-upload-success saves them like any other source. */
  public onPhoneFilesReceived(files: PhoneUploadFile[]) {
    this.phoneFileFeeder.add(files);
  }

  /** Desktop only: "Add from computer" (direct S3 / Mux path) and Scan to Upload inside the widget. */
  private connectUploaderPlugins() {
    if (!this.isBrowser) {
      return;
    }
    const config: any = this.hostElement.nativeElement.querySelector('uc-config');
    if (config && this.showPhoneUpload) {
      config.plugins = [
        createComputerUploadPlugin({
          openFilePicker: () => this.triggerFileInput(),
          // Same shape as the file input's change event, so it takes the Upload button's path.
          onFiles: files => this.uploadDATA({ target: { files, value: '' } })
        }),
        // One file per code inside the widget: the modal closes after it, which ends the code.
        this.phoneUploadMounter.createPlugin(() => ({ ...this.phoneUploadContext, maxFiles: 1 }))
      ];
    }
    // uploadData() runs in onInit, before this component's provider is in the DOM.
    if (!this.apiCollection) {
      this.uploadData();
    }
  }

public uploadData() {
    if(!this.isBrowser) return;

    const providerNode: any = document.querySelector("uc-upload-ctx-provider");
    const previewsNode = document.getElementById("previews");
    const config:any = document.querySelector("uc-config");

// Set custom error
if(config){
  config.localeDefinitionOverride = {
    en: {
      "files-max-size-limit-error":
        "File size too large! Please download and upload the file locally",
    },
  };
}


    if (!providerNode) return;

    this.apiCollection = providerNode.getAPI();
    
    providerNode.addEventListener('change', e => {
      console.log(e);
    });

    providerNode.addEventListener('file-added', e => {
      console.log(e);
    });

    providerNode.addEventListener('file-upload-failed', e => {
      const error = e.detail.errors[0];
      if (
        error.type === "UPLOAD_ERROR" &&
        error.message.includes("Downloaded file is too big")
      ) {
        // alert(
        //   "File size exceeds 300MB! Please download the file and upload it locally."
        // );
        this.toastService.error("File size exceeds 300MB! Please download the file and upload it locally.")
      }
    });
    providerNode.addEventListener('file-upload-success', (e:any) => {
      if (!e.detail.fileInfo) return;

      setTimeout(()=>{
        const donebutton  = document.querySelector('.uc-done-btn') as HTMLElement;
        // const donateInner = donebutton.querySelector('button')
        if(donebutton){
          donebutton.click();
        }
  
      },300)

      if(e.detail.fileInfo.isImage) {
        this.store$.dispatch(new mediaDownloadAction.CheckDownloaf(true));
        this.store$.dispatch(new mediaActions.GetExternalBlob(true));
        fetch(e.detail.fileInfo.cdnUrl)
        .then(response => response.blob())
         .then(blob => {
          this.store$.dispatch(new mediaDownloadAction.CheckDownloaf(false));
          this.store$.dispatch(new mediaActions.GetExternalBlob(false));
          const imageEditedBlob = blob;
          imageEditedBlob['path'] = 'story-image';
          this.uploader.addBlobs(imageEditedBlob);
         });
      } else if (!e.detail.fileInfo.isImage) {
        this.store$.dispatch(new mediaDownloadAction.CheckDownloaf(true));
        this.store$.dispatch(new mediaActions.GetExternalBlob(true));
        fetch(e.detail.fileInfo.cdnUrl)
        .then(response => response.blob())
         .then(blob => {
          const fileName = 'example.mp4'; // Replace with your desired filename
          const file = new File([blob], fileName, { type: blob.type });
          this.store$.dispatch(new mediaActions.GetVideochunks(file));
          this.store$.dispatch(new mediaActions.GetExternalBlob(false));
         });
    
      }
    });
  }

}
